import { EmptyState } from '@/components/ui/States'
import type { ConfusionPair } from '@/types/domain'

/**
 * Which tool was chosen instead of the expected one.
 *
 * This is the single actionable output of the whole evaluation: each row names two tool
 * descriptions that a model could not tell apart, which is exactly the pair to rewrite.
 * The arrow here maps one value to another — it is the content, not button chrome.
 */
export function ConfusionList({ pairs }: { pairs: ConfusionPair[] }) {
  if (pairs.length === 0) {
    return (
      <EmptyState
        title="No tools were confused."
        hint="Every query that selected a tool selected the expected one."
      />
    )
  }

  return (
    <ul className="divide-y divide-line/60">
      {pairs.map((pair) => (
        <li
          key={`${pair.expected_tool}-${pair.selected_tool}`}
          className="flex items-center justify-between gap-4 px-4 py-2.5"
        >
          <span className="flex min-w-0 flex-wrap items-center gap-2">
            <span className="mono truncate text-ink-dim">{pair.expected_tool}</span>
            <span className="text-ink-faint" aria-label="was answered with">
              →
            </span>
            <span className="mono truncate text-miss">{pair.selected_tool}</span>
          </span>
          <span className="mono shrink-0 text-ink-muted">
            {pair.count}×
          </span>
        </li>
      ))}
    </ul>
  )
}
